import type { Atlas } from '@/models/interfaces/Atlas'
import { apiClient } from '@/plugins/axios/api'

export class AtlasService {
  static async getAll() {
    try {
      const response = await apiClient.get('/api/atlases')
      // L'intercepteur Axios gère déjà les erreurs 404 en retournant un tableau vide
      return response.data['hydra:member'] || []
    } catch {
      // Fallback au cas où l'intercepteur ne gérerait pas l'erreur
      console.debug('Atlas endpoint not available yet, returning empty array.')
      return []
    }
  }

  static async post(atlas: Atlas): Promise<Atlas> {
    return await apiClient.post('/api/atlases', atlas).then((response) => response.data)
  }

  static async patch(atlas: Atlas): Promise<Atlas> {
    return await apiClient
      .patch('/api/atlases/' + atlas.id, atlas)
      .then((response) => response.data)
  }

  static async delete(atlas: Atlas): Promise<Atlas> {
    return await apiClient.delete('/api/atlases/' + atlas.id).then((response) => response.data)
  }
}
